import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MobileSizeFirstLook from './mobile-size-steps/MobileSizeFirstLook';
import MobileSizeNotifications from './mobile-size-steps/MobileSizeNotifications';
import MobileSizeSupport from './mobile-size-steps/MobileSizeSupport';
import MobileSizeSupportOpinion from './mobile-size-steps/MobileSizeSupportOpinion';
import MobileSizeSupportThanks from './mobile-size-steps/MobileSizeSupportThanks';
import { StyledMobileDrawer } from './MobileDrawer.styles';

export const MobileDrawer = ({
  avatar,
  user,
  logout,
  onToggle,
  close,
  open,
}) => {
  const layoutProfileMenuStep = useSelector(
    (state) => state.pageReducer.layoutProfileMenuStep
  );

  const components = {
    step_1: (
      <MobileSizeFirstLook
        avatar={avatar}
        user={user}
        logout={logout}
        close={close}
      />
    ),
    step_2: <MobileSizeNotifications close={close} />,
    step_4: <MobileSizeSupport close={close} />,
    step_5: <MobileSizeSupportOpinion close={close} />,
    step_6: <MobileSizeSupportThanks close={close} />,
  };

  return (
    <>
      <StyledMobileDrawer
        open={open}
        onToggle={onToggle}
        className='profile-menu mobile-drawer'
      >
        <div className='menu-wrapper'>{components[layoutProfileMenuStep]}</div>
      </StyledMobileDrawer>
    </>
  );
};

MobileDrawer.propTypes = {
  avatar: PropTypes.string,
  user: PropTypes.object,
  logout: PropTypes.func,
  close: PropTypes.func,
  onToggle: PropTypes.func,
  open: PropTypes.bool,
};
